// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueResource from 'vue-resource';
import router from '@/router.js';
import store from '@/store.js';
import App from '@/app/App';
import Vuelidate from 'vuelidate';
import MultiLanguage from 'vue-multilanguage';

import LanguageEN from '@/languages/en.json';
import LanguageSE from '@/languages/se.json';
import LanguageNO from '@/languages/no.json';
import LanguageIS from '@/languages/is.json';

import Datetime from 'vue-datetime';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import CKEditor from "@ckeditor/ckeditor5-vue";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import { PropertyKeys } from "ag-grid-community/dist/lib/propertyKeys";
import { ColDefUtil } from "ag-grid-community/dist/lib/components/colDefUtil";

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';

const R = require('ramda');
// import "./libs/css/ckeditor.css"
// fix wrong property warning
PropertyKeys.ALL_PROPERTIES.push("__ob__");
ColDefUtil.ALL_PROPERTIES.push("__ob__");

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(MultiLanguage, {
  default: 'se',
  en: LanguageEN,
  se: LanguageSE,
  no: LanguageNO,
  is: LanguageIS,
});

Vue.use(CKEditor);
Vue.use(Datetime);
Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(R);
window.Vue = Vue;
Vue.use(Vuelidate);
Vue.use(VueNotifications, options);

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  store: store,
  router,
  beforeCreate() {
    Object.defineProperty(Vue.prototype, 'R', { value: R });
  },
  beforeMount() {
    // unregister service worker for prevent unused caching for admin part
    if (window.navigator && navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations()
        .then(function(registrations) {
          for (const registration of registrations) {
            registration.unregister();
          }
        });
    }
    if (!localStorage.langType) {
      localStorage.langType = this.language;
    }
  },
  render: h => h(App),
});
